import { rankWith, uiTypeIs } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";
import { get } from "lodash";
import { MoreInfoTooltipDynamicForms } from "../../../../../elements/Tooltip";
import { getLabel } from "../../../../../utils/DynamicForms";
import { FieldProps, WithDynamicFormContext } from "../WithDynamicFormContext";
import "./style.scss";

const DisplayInput = (props: FieldProps) => {
  const moreInfo = props.uischema?.options?.moreInfo;
  const isStatic = props?.uischema?.options?.static;
  const value = props?.uischema?.options?.value;

  return (
    <div className="accordion-content-gk animate__animated animate__fast animate__fadeIn">
      <div className="headers-col-gk">
        <div className="td">{getLabel(props.uischema)}</div>
      </div>
      <div className="data-columns-gk">
        <div className="data-column-gk">
          <div className="td">
            {!isStatic && <span>${get(props.formData, props.path)}</span>}
            {isStatic &&
              (value ? (
                <span>{value}</span>
              ) : (
                <span>{get(props.formData, props.path)}</span>
              ))}
          </div>
        </div>
      </div>
      {moreInfo && <MoreInfoTooltipDynamicForms moreInfo={moreInfo} />}
    </div>
  );
};

export const DisplayInputEntry = {
  tester: rankWith(1, uiTypeIs("DisplayInput")),
  renderer: withJsonFormsControlProps(WithDynamicFormContext(DisplayInput)),
};
